module.exports = __webpack_public_path__ + "static/img/Icon-Maining Opt-in.d186b9de.svg";